import { getFutureDate, reverseFormatDate } from '../../../utils/dateFunctions';
import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import {
    getAddMessage,
    getDateMinMessage,
    getDateMinOrSameMessage,
    getDuplicatedMessage,
    getNowDateOrEarlierMessage,
    getReqMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const validate = (entries, initialState) => {
    let newErrors = {};

    if (entries.length < 1) {
        newErrors = {
            ...newErrors,
            institutions: { error: true, message: getAddMessage('institution') }
        };
    }

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(entries, initialState);

    return newErrors;
};

export const validateCard = (newEntry, initialState, type, dateOfBirth) => {
    let newErrors = {};

    if (!newEntry.name) {
        newErrors = {
            ...newErrors,
            name: { error: true, message: getReqMessage('An institution name') }
        };
    }

    if (!newEntry.qualificationTypeId) {
        newErrors = {
            ...newErrors,
            qualificationTypeId: { error: true, message: getReqMessage('A qualification type') }
        };
    }

    if (newEntry.subjects.length < 1 || newEntry.subjects[0].subject === '') {
        newErrors = {
            ...newErrors,
            subjects: { error: true, message: getReqMessage('At least one subject') }
        };
    } else if (newEntry.subjects.length > 1 && checkForDuplicates(newEntry.subjects)) {
        newErrors = {
            ...newErrors,
            subjects: { error: true, message: getDuplicatedMessage('Subjects') }
        };
    }
    if (newEntry.startDate && newEntry.startDate <= dateOfBirth) {
        newErrors = {
            ...newErrors,
            startDate: { error: true, message: getDateMinMessage(reverseFormatDate(dateOfBirth)) }
        };
    } else if (newEntry.startDate && getFutureDate(newEntry.startDate)) {
        newErrors = {
            ...newErrors,
            startDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (!newEntry.onGoing && !newEntry.endDate) {
        newErrors = {
            ...newErrors,
            endDate: { error: true, message: getReqMessage('End date') }
        };
    } else if (newEntry.endDate && newEntry.endDate < newEntry.startDate) {
        newErrors = {
            ...newErrors,
            endDate: { error: true, message: getDateMinOrSameMessage('start date') }
        };
    } else if (newEntry.endDate && getFutureDate(newEntry.endDate)) {
        newErrors = {
            ...newErrors,
            endDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (type === 'edit' && Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialState);

    return newErrors;
};

const checkForDuplicates = (arr) => {
    return [...new Set(arr.map((el) => el.subject))].length < arr.length;
};
